import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  format() {
    this.inputTarget.value = this.inputTarget.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 6)
  }

  submit(event) {
    event.preventDefault()
    const code = this.inputTarget.value.trim().toUpperCase()
    if (code.length === 6) {
      window.location.href = `/rooms/${encodeURIComponent(code)}/join`
    }
  }
}
